import { translationUploadData_da } from "./translationUploadData.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationUploadData_en } from "./translationUploadData.en";

export const translationUploadData = defineBilingualTranslations({
  da: translationUploadData_da,
  en: translationUploadData_en,
});
